"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchEcommerceWorkflowIdsRequestStatus = exports.getHasAccessToWorkflows = void 0;

var _getRequestStatus = _interopRequireDefault(require("../RequestStatuses/getRequestStatus"));

var _reselect = require("reselect");

var _actions = require("./actions");

var _selectors = require("settings-ui-sdk/Auth/selectors");

var getHasAccessToWorkflows = (0, _reselect.createSelector)([_selectors.getUserScopes], function (scopes) {
  return scopes.includes('workflows-email-access');
});
exports.getHasAccessToWorkflows = getHasAccessToWorkflows;
var getFetchEcommerceWorkflowIdsRequestStatus = (0, _getRequestStatus.default)(_actions.EcommerceWorkflowsActionTypes.FETCH_WORKFLOW_IDS);
exports.getFetchEcommerceWorkflowIdsRequestStatus = getFetchEcommerceWorkflowIdsRequestStatus;